export const EXTERNAL_AD_CONFIG = {
  DESKTOP: {
    HP: {
      AD970X90: {
        adUnit: '/183758631/Banner_Desktop_Web_970x90_HomePage_TopScreen',
        width: 970,
        height: 90,
        validLayouts: [1, 2, 3],
        slotId: 'hp-top-screen',
        collapseEmptyDiv: false
      },
      AD300X250: {
        adUnit: '/183758631/Banner_Desktop_Web_336x280_HomePage_Sidebar1',
        width: 300,
        height: 250,
        validLayouts: [1, 2, 3],
        slotId: 'hp-sidebar-1',
        collapseEmptyDiv: true
      },
      AD336X280: {
        adUnit: '/183758631/Banner_Desktop_Web_336x280_HomePage_Sidebar2',
        width: 336,
        height: 280,
        validLayouts: [1, 2, 3],
        slotId: 'hp-sidebar-2',
        collapseEmptyDiv: true
      },
      AD728X80: {
        adUnit: '/183758631/Banner_Desktop_Web_728x90_HomePage_Mid1',
        height: 90,
        width: 728,
        validLayouts: [1, 2, 3],
        slotId: 'hp-mid-1',
        collapseEmptyDiv: true
      }
    },
    ATHLETE: {
      AD336X280: {
        adUnit: '/183758631/Banner_Desktop_Web_336x280_Athlete_Sidebar1',
        width: 336,
        height: 280,
        validLayouts: [1, 2, 3],
        slotId: 'athlete-sidebar-1',
        collapseEmptyDiv: true
      },
      AD728X80: {
        adUnit: '/183758631/Banner_Desktop_Web_728x90_Athlete_Mid1',
        height: 90,
        width: 728,
        validLayouts: [1, 2, 3],
        slotId: 'athlete-mid-1',
        collapseEmptyDiv: true
      },
      AD970X90: {
        adUnit: '/183758631/Banner_Desktop_Web_970x90_Athlete_TopScreen',
        width: 970,
        height: 90,
        validLayouts: [1, 2, 3],
        slotId: 'athlete-top-screen',
        collapseEmptyDiv: false
      }
    },
    COMPETITION: {
      AD970X90: {
        adUnit: '/183758631/Banner_Desktop_Web_970x90_Competition_TopScreen',
        width: 970,
        height: 90,
        validLayouts: [1, 2, 3],
        slotId: 'competition-top-screen',
        collapseEmptyDiv: false
      },
      AD336X280: {
        adUnit: '/183758631/Banner_Desktop_Web_336x280_Competition_Sidebar1',
        width: 336,
        height: 280,
        validLayouts: [1, 2, 3],
        slotId: 'competition-sidebar-1',
        collapseEmptyDiv: true
      },
      AD728X80: {
        adUnit: '/183758631/Banner_Desktop_Web_728x90_Competition_Mid1',
        height: 90,
        width: 468,
        validLayouts: [1, 2, 3],
        slotId: 'competition-mid-1',
        collapseEmptyDiv: true
      }
    },
    COMPETITOR: {
      AD970X90: {
        adUnit: '/183758631/Banner_Desktop_Web_970x90_Competitor_TopScreen',
        width: 970,
        height: 90,
        validLayouts: [1, 2, 3],
        slotId: 'competitor-top-screen',
        collapseEmptyDiv: true
      },
      AD336X280: {
        adUnit: '/183758631/Banner_Desktop_Web_336x280_Competitor_Sidebar1',
        width: 336,
        height: 280,
        validLayouts: [1, 2, 3],
        slotId: 'competitor-sidebar-1',
        collapseEmptyDiv: true
      },
      AD728X80: {
        adUnit: '/183758631/Banner_Desktop_Web_728x90_Competitor_Mid1',
        height: 90,
        width: 468,
        validLayouts: [1, 2, 3],
        slotId: 'competitor-mid-1',
        collapseEmptyDiv: true
      }
    },
    MATCH: {
      AD970X90: {
        adUnit: '/183758631/Banner_Desktop_Web_970x90_Match_TopScreen',
        width: 970,
        height: 90,
        validLayouts: [1, 2, 3],
        slotId: 'match-top-screen',
        collapseEmptyDiv: false
      },
      AD336X280: {
        adUnit: '/183758631/Banner_Desktop_Web_336x280_Match_Sidebar1',
        width: 336,
        height: 280,
        validLayouts: [1, 2, 3],
        slotId: 'match-sidebar-1',
        collapseEmptyDiv: true
      },
      AD728X80: {
        adUnit: '/183758631/Banner_Desktop_Web_728x90_Match_Mid1',
        height: 90,
        width: 468,
        validLayouts: [1, 2, 3],
        slotId: 'match-mid-1',
        collapseEmptyDiv: true
      }
    },
    STICKY: {
      AD970X90: {
        adUnit: '/183758631/Banner_Desktop_Web_970x90_HomePage_Sticky',
        height: 90,
        width: 970,
        validLayouts: [1, 2, 3],
        slotId: 'hp-sticky',
        collapseEmptyDiv: true
      }
    },
    SKYSCRAPPER: {
      AD120X600: {
        adUnit: '/183758631/Banner_Desktop_Web_Skyscrapper',
        width: 120,
        height: 600,
        sizes: [
          [120, 600],
          [160, 600]
        ],
        validLayouts: [1, 2, 3],
        slotId: 'skyscrapper-ad',
        collapseEmptyDiv: true
      }
    },
    INTERSTITIAL: {
      adUnit: '/183758631/Web_desktop_inter',
      width: 640,
      height: 1280,
      sizes: [
        [300, 250],
        [320, 480],
        [336, 280],
        [1024, 768],
        [1600, 900],
        [200, 200],
        [250, 250],
        [300, 600],
        [580, 400]],
      validLayouts: [1, 2, 3],
      slotId: 'web_interstitial_slot_365'
    }
  },
  MOBILE: {
    HP: {
      AD320X100: {
        adUnit: '/183758631/Banner_Moblie_Web_320x100_HomePage_TopScreen',
        width: 320,
        height: 100,
        sizes: [
          [300, 50],
          [300, 100],
          [320, 50],
          [320, 100],
        ],
        validLayouts: [1, 2, 3],
        slotId: 'hp-top-screen',
        collapseEmptyDiv: false
      },
      AD320X100_MID1: {
        adUnit: '/183758631/Banner_Moblie_Web_336x280_HomePage_Mid1',
        width: 320,
        height: 100,
        validLayouts: [1, 2, 3],
        slotId: 'hp-mid-1',
        collapseEmptyDiv: true
      },
      AD300X250_MID2: {
        adUnit: '/183758631/Banner_Moblie_Web_336x280_HomePage_Mid2',
        width: 300,
        height: 250,
        validLayouts: [1, 2, 3],
        slotId: 'hp-mid-2',
        collapseEmptyDiv: true
      }
    },
    ATHLETE: {
      AD320X100: {
        adUnit: '/183758631/Banner_Moblie_Web_320x100_Athlete_TopScreen',
        width: 320,
        height: 100,
        sizes: [
          [300, 50],
          [300, 100],
          [320, 50],
          [320, 100],
        ],
        validLayouts: [1, 2, 3],
        slotId: 'athlete-top-screen',
        collapseEmptyDiv: false
      },
      AD300X250_MID1: {
        adUnit: '/183758631/Banner_Moblie_Web_336x280_Athlete_Mid1',
        width: 300,
        height: 250,
        validLayouts: [1, 2, 3],
        slotId: 'athlete-mid-1',
        collapseEmptyDiv: true
      },
      AD300X250_MID2: {
        adUnit: '/183758631/Banner_Moblie_Web_336x280_Athlete_Mid2',
        width: 300,
        height: 250,
        validLayouts: [1, 2, 3],
        slotId: 'athlete-mid-2',
        collapseEmptyDiv: true
      }
    },
    COMPETITION: {
      AD320X100: {
        adUnit: '/183758631/Banner_Moblie_Web_320x100_Competition_TopScreen',
        width: 320,
        height: 100,
        sizes: [
          [300, 50],
          [300, 100],
          [320, 50],
          [320, 100],
        ],
        validLayouts: [1, 2, 3],
        slotId: 'competition-top-screen',
        collapseEmptyDiv: false
      },
      AD320X250_MID1: {
        adUnit: '/183758631/Banner_Moblie_Web_336x280_Competition_Mid1',
        width: 320,
        height: 100,
        validLayouts: [1, 2, 3],
        slotId: 'competition-mid-1',
        collapseEmptyDiv: true
      },
      AD300X250_MID2: {
        adUnit: '/183758631/Banner_Moblie_Web_336x280_Competition_Mid2',
        width: 336,
        height: 280,
        validLayouts: [1, 2, 3],
        slotId: 'competition-mid-2',
        collapseEmptyDiv: true
      },
      AD300X250_MID1_STANDINGS: {
        adUnit: '/183758631/Banner_Moblie_Web_336x280_Competition_Mid1',
        width: 336,
        height: 280,
        validLayouts: [1, 2, 3],
        slotId: 'competition-mid-1-standings',
        collapseEmptyDiv: true
      },
      AD300X250_MID1_STATS: {
        adUnit: '/183758631/Banner_Moblie_Web_336x280_Competition_Mid1',
        width: 300,
        height: 250,
        validLayouts: [1, 2, 3],
        slotId: 'competition-mid-1-stats',
        collapseEmptyDiv: true
      }
    },
    COMPETITOR: {
      AD320X100: {
        adUnit: '/183758631/Banner_Moblie_Web_320x100_Competitor_TopScreen',
        width: 320,
        height: 100,
        sizes: [
          [300, 50],
          [300, 100],
          [320, 50],
          [320, 100],
        ],
        validLayouts: [1, 2, 3],
        slotId: 'competitor-top-screen',
        collapseEmptyDiv: false
      },
      AD320X250_MID1: {
        adUnit: '/183758631/Banner_Moblie_Web_336x280_Competitor_Mid1',
        width: 320,
        height: 100,
        validLayouts: [1, 2, 3],
        slotId: 'competitor-mid-1',
        collapseEmptyDiv: true
      },
      AD300X250_MID2: {
        adUnit: '/183758631/Banner_Moblie_Web_336x280_Competitor_Mid2',
        width: 336,
        height: 280,
        validLayouts: [1, 2, 3],
        slotId: 'competitor-mid-2',
        collapseEmptyDiv: true
      },
      AD320X250_MID1_1_STANDINGS: {
        adUnit: '/183758631/Banner_Moblie_Web_336x280_Competitor_Mid1',
        width: 336,
        height: 280,
        validLayouts: [1, 2, 3],
        slotId: 'competitor-mid-1-standings',
        collapseEmptyDiv: true
      }
    },
    MATCH: {
      AD320X100: {
        adUnit: '/183758631/Banner_Moblie_Web_320x100_Match_TopScreen',
        width: 320,
        height: 100,
        sizes: [
          [300, 50],
          [300, 100],
          [320, 50],
          [320, 100],
        ],
        validLayouts: [1, 2, 3],
        slotId: 'match-top-screen',
        collapseEmptyDiv: false
      },
      AD320X250_MID1: {
        adUnit: '/183758631/Banner_Moblie_Web_336x280_Match_Mid1',
        width: 336,
        height: 280,
        validLayouts: [1, 2, 3],
        slotId: 'match-mid-1',
        collapseEmptyDiv: true
      },
      AD300X250_MID2: {
        adUnit: '/183758631/Banner_Moblie_Web_336x280_Match_Mid2',
        width: 336,
        height: 280,
        validLayouts: [1, 2, 3],
        slotId: 'match-mid-2',
        collapseEmptyDiv: true
      }
    },
    STICKY: {
      AD320X100: {
        adUnit: '/183758631/Banner_Moblie_Web_320x100_HomePage_Sticky',
        height: 50,
        width: 360,
        sizes: [
          [300, 50],
          [300, 100],
          [320, 50],
          [320, 100],
        ],
        validLayouts: [1, 2, 3],
        slotId: 'hp-sticky',
        collapseEmptyDiv: true
      },
      AD320X50: {
        adUnit: '/183758631/Banner_Moblie_Web_320x100_HomePage_Sticky',
        height: 50,
        width: 320,
        sizes: [
          [320, 50],
        ],
        validLayouts: [1, 2, 3],
        slotId: 'hp-sticky',
        collapseEmptyDiv: true
      }
    },
    INTERSTITIAL: {
      adUnit: '/183758631/Web_mobile_inter',
      width: 640,
      height: 1280,
      sizes: [
        [300, 250],
        [320, 480],
        [336, 280],
        [200, 200],
        [250, 250],
        [300, 600],
      ],
      validLayouts: [1, 2, 3],
      slotId: 'web_interstitial_slot_365'
    },
  },
  CONFIG: {
    INTERSTITIAL_TIME_FREQUENCY_SEC: 600 //10 Minutes
  },
  VIGNETTE: {
    adUnit: '/183758631/MagazineWeb_Vignette',
    validLayouts: [1, 2, 3]
  }
}

